import React, { CSSProperties } from "react";
import { useParams } from "react-router-dom";
import { Image } from "antd";
import img from "../../../assets/images/user.png";
import { wrap } from "module";
import WithAuth from "../../hoc/WithAuth";
import { useUserDetail } from "../../api/users";

const wrapper: CSSProperties = {
  display: "flex",
  gap: 10,
  fontSize: 16,
  marginBottom: 20,
  flexDirection: "column",
};
const label: CSSProperties = {
  color: "#128807",
  fontWeight: 500,
  fontSize: 20,
};
const value: CSSProperties = {
  color: "#8590A3",
  fontWeight: 500,
  fontSize: 16,
};

const UserDetailPage = () => {
  const { id } = useParams();

  const { data: user } = useUserDetail(id || "");

  return (
    <div style={{ marginBottom: 50 }}>
      {user && user.data && (
        <div
          className="flex flex-col rounded-xl mt-[25px] md:px-[50px] md:pt-[22px] bg-white md:p-5"
          style={{ fontFamily: "Poppins" }}
        >
          {/* {user.data.avatar_url && <Image preview={false} src={user.data.avatar_url} style={{ width: 200, height: 200, borderRadius: 100 }} />}
        {!user.data.avatar_url && <Image preview={false} src={img} style={{ width: 200, height: 200, borderRadius: 100 }} />} */}
          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <div style={{ width: "90%" }}>
              <div
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 700,
                  width: "100%",
                  borderRadius: "8.5px",
                  backgroundColor: "white",
                  padding: "33px",
                  paddingLeft: 0,
                  paddingRight: 0,
                }}
              >
                <div
                  style={{
                    backgroundColor: "#E9EDF4",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    paddingTop: "15px",
                    paddingBottom: "15px",
                    borderRadius: "8.5px",
                    fontWeight: 500,
                    fontSize: "24px",
                    marginBottom: "30px",
                  }}
                >
                  User Profile
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 20,
                  }}
                >
                  <div style={wrapper}>
                    <div style={label}>Company name</div>
                    <div style={value}>{user.data.data.organization}</div>
                  </div>
                </div>
                <div className="w-full gap-x-4 flex flex-wrap justify-between md:grid-cols-3 mb-5">
                  <div style={wrapper}>
                    <div style={label}>Full name</div>
                    <div style={value}>{user.data.data.fullName}</div>
                  </div>

                  <div style={wrapper}>
                    <div style={label}>Phone</div>
                    <div style={value}>{user.data.data.phoneNo}</div>
                  </div>

                  <div style={wrapper}>
                    <div style={label}>Email</div>
                    <div style={value}>{user.data.data.email}</div>
                  </div>
                </div>
                <div className="w-full gap-x-4 flex flex-wrap justify-between md:grid-cols-3 mb-5">
                  <div style={wrapper}>
                    <div style={label}>Role</div>
                    <div style={value}>{user.data.data.role}</div>
                  </div>

                  <div style={wrapper}>
                    <div style={label}>User name</div>
                    <div style={value}>{user.data.data.username}</div>
                  </div>

                  <div style={wrapper}>
                    <div style={label}>Status</div>
                    <div
                      style={{
                        ...value,
                        borderRadius: 5,
                        display: "flex",
                        justifyContent: "center",
                        width: 120,
                        paddingTop: 6,
                        paddingBottom: 6,
                        color:
                          user.data.data.isActive === "1"
                            ? "#4CAF50"
                            : "#F44336",
                        backgroundColor: `${user.data.data.isActive === "1" ? "#4CAF50" : "#F44336"}44`,
                      }}
                    >
                      {user.data.data.isActive === "1" ? "ACTIVE" : "INACTIVE"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WithAuth(UserDetailPage);
